import React from 'react'
import classNames from 'classnames'

import LargeText from '@/large-text'
import Button from '@/button'
import Container from '@/container'

import './styles.css'

const GetStartedSteps = () => {
  const stepsData = [
    {
      title: 'Fill Next Miss form',
      text: 'Enabling beauty pageants to work in a simpler smarter way.',
      time: '5 minutes',
      button: <Button color="gold" size="sm">FILL NEXT MISS FORM</Button>
    },
    {
      title: 'We will contact you',
      text: 'Once we have received your form, we will contact you under 24 hours. Together we agree the next steps and the digital tools that will be used for your business.',
      time: '24 hours'
    },
    {
      title: 'Next Miss receives your materials',
      text: 'Once we have received your materials (names, images, timeline, etc) needed for your casting or voting, we are ready to go live.',
      time: '15 minutes'
    },
    {
      title: 'You go live',
      text: 'We will launch your casting or voting at a time of your choosing. We provide promotion recommendations for contestants, social, online medias & TV.',
      time: '24 hours'
    }
  ]

  return (
    <div>
      {stepsData.map(({ title, text, time, button }, i) => {
        const index = i + 1

        return (
          <div
            key={`get-step-${i}`}
            className={classNames({
              'pv5 pv6-m': true,
              'bg-near-white': index % 2
            })}
          >
            <Container>
              <div className="flex">
                <div className="gold f90 tc mr3 mr4-m mr5-l">{index}</div>

                <div className="flex-m justify-between flex-grow-1">
                  <div className="mr4-m">
                    <h3 className="f6 f5-m f4-l fw5 mt0 mb2 mb3-m mb4-l">{title}</h3>
                    <LargeText align="left">
                      {text}
                    </LargeText>
                    {button}
                  </div>
                  <div className="f8 f7-m f6-l gold fw3 nowrap i mt3 mt0-m">under {time}</div>
                </div>
              </div>
            </Container>
          </div>
        )
      })}
    </div>
  )
}

export default GetStartedSteps



// WEBPACK FOOTER //
// ./src/components/section-apply-survey/get-started-steps/get-started-steps.js